import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { useLocalization } from "gatsby-theme-i18n"

const useTopicCollection = () => {
  const { locale } = useLocalization()

const data = useStaticQuery(graphql`
  query AllCollectionTopicsQuery {
    topics: allCollectionTopics(sort: { order: ASC }) {
      nodes {
        id
        title
        url
        locale
        icon {
          value
        }
      }
    }
  }
`)

  /**
   * Get all Topics in the current locale
   */
  return React.useMemo(
    () =>
      data.topics.nodes
        .filter(n => n.locale === locale)
        .map(node => {
          if (node.icon?.value) {
            node.icon.value =
              node.icon.value.charAt(0).toUpperCase() +
              node.icon.value.slice(1).toLowerCase().replaceAll("-", "")
          }
          return node
        }),
    [data, locale]
  )
}

export default useTopicCollection
